<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />

    <div>

        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />
        <v-row :style="`margin-top:0;direction:`+lang.dir+`;padding-inline:50px;`">
            <v-col cols="12" class="text-end">
                <b-button id="multiply-button" :class="`mt-10 multiply-button-`+lang.lalgin"
                :style="`width:150px;background:transparent;border:none`"
                @click="resetPayType()"
                v-b-toggle.add_paytype>
              <div style="width:150px;color:#000;white-space:nowrap;" :class="`multiply-button-content-`+lang.lalgin">{{lang.add_pay_type}}</div></b-button>
            </v-col>
        </v-row>
        <v-simple-table class="mt-4" style="padding-inline:40px;">
            <thead>
                <tr>
                    <th class="backBlack text-center">{{lang.namear}}</th>
                    <th class="backBlack text-center">{{lang.nameen}}</th>
                    <th class="backBlack text-center">{{lang.classid}}</th>
                    <th class="backBlack text-center">{{lang.type}}</th>
                    <th class="backBlack text-center">{{lang.classid_balanced}}</th>
                    <th class="backBlack text-center" colspan="1">{{lang.action}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in paytypesrows" :key="index">
                    <td>{{item.type_name}}</td>
                    <td>{{item.type_name_en}}</td>
                    <td>{{item.classid}}</td>
                    <td v-if="item.balanced_type == 1">{{ lang.general_payment}}</td>
                    <td v-if="item.balanced_type == 2">{{ lang.balanced_payments}}</td>
                    <td>{{item.classid_balanced}}</td>
                    <td style="width:100px;background:#000;border-bottom:1px solid #fff !important;padding:1px">
                        <b-button class="btn-sm btn-default" style="color:#FFF;background:#000;width:100px;height:25px !important;margin-left:5px;border:none" @click="edit(item)" v-b-toggle.add_paytype>{{lang.update}} &nbsp;	&nbsp;	<i :class="`fas fa-caret-`+lang.lalgin"></i></b-button>
                    </td>
                    <!-- <td style="width:100px;background:green;border-bottom:1px solid #fff !important;padding:1px">
                        <b-button class="btn-sm btn-default" style="color:#FFF;background:green;width:100px;height:25px !important;margin-left:5px;border:none" @click="getStatement(item)" v-b-toggle.show_statment>{{lang.client_statement}} &nbsp;	&nbsp;	<i :class="`fas fa-caret-`+lang.lalgin"></i></b-button>
                    </td> -->
                </tr>
            </tbody>
        </v-simple-table>
        <finance-statement ref="showStat" />
        <add-pay-type ref="addPaytype" />
    </div>
        <Footer />
    </div>
</template>

<script>
import breadCrumbs from '@/components/breadCrumbs.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios';
import FinanceStatement from '@/components/finance-statement.vue';
import AddPayType from '@/components/addPayType.vue';
import Footer from '@/components/Footer.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import ExportsPrint from '@/components/exports-print.vue'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default {
    components: { breadCrumbs, TabsComp, FinanceStatement, AddPayType, HeaderPortrate,Footer,ExportsPrint },
    data() {
        return {
            paytypesrows: [],
            sdate: new Date().toISOString().substring(0, 10),
            edate: new Date().toISOString().substring(0, 10),
            accountrows: [],
        }
    },
    created() {
        this.getPyamentType();
    },
    methods: {
        edit(item){
            this.$refs.addPaytype.type_name = item.type_name;
            this.$refs.addPaytype.type_name_en = item.type_name_en;
            this.$refs.addPaytype.classid = item.classid;
            this.$refs.addPaytype.classid_balanced = item.classid_balanced;
            this.$refs.addPaytype.balanced_type = item.balanced_type;
            this.$refs.addPaytype.id = item.id;
            this.$refs.addPaytype.getClassname(item.classid,1);
            this.$refs.addPaytype.getClassname(item.classid_balanced,2);
            this.$refs.addPaytype.pagetitle = this.lang.update;
        },
        resetPayType(){
            this.$refs.addPaytype.type_name = '';
            this.$refs.addPaytype.type_name_en = '';
            this.$refs.addPaytype.classid = '';
            this.$refs.addPaytype.id = '';
            this.$refs.addPaytype.class_name = '';
            this.$refs.addPaytype.pagetitle = this.lang.add_pay_type;
        },
        getStatement(item){
            this.$refs.showStat.accountn = item;
        },
        getPyamentType(){
            const post = new FormData();
            post.append('type','getPayTypes');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.paytypesrows = res.results.data;

            })
        },
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        tabs: function() {

            return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

        },
        items: function() {
            return {
                    text: this.lang.paytypes,
                    disabled: true,
                    to: '/finance/paytypes',
                }
        },

    },
}
</script>